'use client';

import clsx from 'clsx';
import { FC } from 'react';
import AppDropdownMenu from '~/components/dropdown-menu';
import AppDropdownItem from '~/components/dropdown-menu/item';
import Icon from '~/components/icon';

import { useCity } from '../context';
import styles from './styles.module.css';

const CitySelectDesktop: FC = () => {
  const { cities, selectedCity, address, getCityHref } = useCity();

  return (
    <AppDropdownMenu
      renderHeadComponent={(isActive) => (
        <div className={clsx(styles.head, isActive && styles.active)}>
          <Icon name="location-marker" className={styles.markerIcon} />
          <span>{address ? `${selectedCity.title}, ${address}` : selectedCity.title}</span>
          <Icon name="chevron" className={styles.chevronIcon} />
        </div>
      )}
      className={styles.dropdown}
      listClassName={styles.list}
    >
      {cities.map((city) => {
        const isActive = city.id === selectedCity.id;

        const optionClassName = clsx(styles.option, isActive && styles.optionActive);

        return (
          <AppDropdownItem key={city.id}>
            {isActive ? (
              <span aria-current="page" className={optionClassName}>
                <span>{city.title}</span>
                <Icon name="check" className={styles.checkIcon} />
              </span>
            ) : (
              <a href={getCityHref(city.id)} className={optionClassName}>
                <span>{city.title}</span>
              </a>
            )}
          </AppDropdownItem>
        );
      })}
    </AppDropdownMenu>
  );
};

export default CitySelectDesktop;
